export default __webpack_public_path__ + "static/media/Helm of Insanity.1450eab2.jpg";